import React, { useEffect, useLayoutEffect, useRef, useState } from "react";
import "../Style/AllCoursesVideos.css";
import judicialLogo from "../Images/judicialLogo.png";
import { useDispatch, useSelector } from "react-redux";
import { getCoursesVideos, updateYoutube } from "../Redux/Auth/AuthSlice";
import Spinner from "../Spinner/Spinner";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faSearch, faPlay, faChevronLeft, faChevronRight } from "@fortawesome/free-solid-svg-icons";

const AllCoursesVideos = () => {
  const dispatch = useDispatch();
  const selector = useSelector((s) => s.AuthSlice);
  // Extract video data from the response
  const getCoursesVideo = selector.getCoursesVideo || [];
  
  const loader = selector.loader;

  const [currentPage, setCurrentPage] = useState(1);
  const videosPerPage = 8;
  const [searchTerm, setSearchTerm] = useState("");
  const [activeTab, setActiveTab] = useState("All"); // Default to "All" tab

  // Filter videos based on tab (All/Active/Inactive) and search term
  const filteredVideos = getCoursesVideo
    .filter((item) => {
      const video = item.video;
      // Filter by active status based on tab
      if (activeTab === "Active" && !video.active) return false;
      if (activeTab === "Inactive" && video.active) return false;
      // No active/inactive filter for "All" tab
      // Apply search filter
      const name = video.name || "";
      const url = video.url || "";
      return (
        name.toLowerCase().includes(searchTerm.toLowerCase()) ||
        url.toLowerCase().includes(searchTerm.toLowerCase())
      );
    })
    .sort((a, b) => a.video.name.localeCompare(b.video.name)) || [];

  const totalPages = Math.ceil(filteredVideos.length / videosPerPage);
  const indexOfLastVideo = currentPage * videosPerPage;
  const indexOfFirstVideo = indexOfLastVideo - videosPerPage;
  const currentVideos = filteredVideos.slice(indexOfFirstVideo, indexOfLastVideo);

  const nextPage = () => {
    if (currentPage < totalPages) setCurrentPage(currentPage + 1);
  };

  const prevPage = () => {
    if (currentPage > 1) setCurrentPage(currentPage - 1);
  };
  const scrollPositionRef = useRef(0);


  // Handle switch toggle
  const handleToggle = (videoId, currentStatus) => {
      scrollPositionRef.current = window.scrollY;

    dispatch(updateYoutube({ videoId, active: !currentStatus }))
      .unwrap()
      .then(() => {
        // Refresh video list after successful update
        dispatch(getCoursesVideos());
      })
      .catch((error) => {
        console.error("Failed to update video status:", error);
      });
  };
useLayoutEffect(() => {
  if (scrollPositionRef.current) {
    window.scrollTo({ top: scrollPositionRef.current, behavior: "auto" });
    scrollPositionRef.current = 0; // Reset after restoring
  }
}, [getCoursesVideo]); // Run this effect after videos are updated

  useEffect(() => {
    dispatch(getCoursesVideos());
  }, [dispatch]);

  return (
    <div className="video-list-main">
      <img className="judicial-logo" src={judicialLogo} alt="Judicial Logo" />
      <h2 className="text-white">Videos List ({filteredVideos.length})</h2>

      <div className="search-container">
        <FontAwesomeIcon icon={faSearch} className="search-icon" />
        <input
          type="text"
          placeholder="Search by video name or URL..."
          value={searchTerm}
          onChange={(e) => {
            setSearchTerm(e.target.value);
            setCurrentPage(1);
          }}
          className="search-input"
        />
      </div>
      <div className="tabs-container">
        <button
          className={`tab-button ${activeTab === "All" ? "active" : ""}`}
          onClick={() => {
            setActiveTab("All");
            setCurrentPage(1);
          }}
        >
          All
        </button>
        <button
          className={`tab-button ${activeTab === "Active" ? "active" : ""}`}
          onClick={() => {
            setActiveTab("Active");
            setCurrentPage(1);
          }}
        >
          Active
        </button>
        <button
          className={`tab-button ${activeTab === "Inactive" ? "active" : ""}`}
          onClick={() => {
            setActiveTab("Inactive");
            setCurrentPage(1);
          }}
        >
          Inactive
        </button>
      </div>

      <div className="table-container">
        <table className="videos-table">
          <thead>
            <tr>
              <th>Sr No.</th>
              <th>Title</th>
              <th>Video Link</th>
              <th>Status</th>
              <th>Action</th>
            </tr>
          </thead>
          {loader ? (
            <tbody>
              <tr>
                <td colSpan="5">
                  <div className="spinner-wrapper">
                    <Spinner />
                  </div>
                </td>
              </tr>
            </tbody>
          ) : (
            <tbody>
              {currentVideos.length > 0 ? (
                currentVideos.map((item, index) => {
                  const video = item.video;
                  return (
                    <tr key={index}>
                      <td>{indexOfFirstVideo + index + 1}</td>
                      <td>{video.name}</td>
                      <td>
                        <a href={video.url} target="_blank" rel="noopener noreferrer">
                          {video.url}
                        </a>
                      </td>
                      <td>
                        <span className={`status-badge ${video.active ? "active" : "inactive"}`}>
                          {video.active ? "Active" : "Inactive"}
                        </span>
                      </td>
                      <td>
                        <div className="action-container">
                          <FontAwesomeIcon
                            icon={faPlay}
                            className="play-icon"
                            onClick={() => window.open(video.url, "_blank", "noopener,noreferrer")}
                            title="Play Video"
                          />
                          <label className="switch">
                            <input
                              type="checkbox"
                              checked={video.active}
                              onChange={() => handleToggle(video._id, video.active)}
                            />
                            <span className="slider"></span>
                          </label>
                        </div>
                      </td>
                    </tr>
                  );
                })
              ) : (
                <tr>
                  <td colSpan="5" className="video-no-data">
                    No videos found
                  </td>
                </tr>
              )}
            </tbody>
          )}
        </table>
      </div>

      {!loader && totalPages > 1 && (
        <div className="pagination">
          <button onClick={prevPage} disabled={currentPage === 1}>
            <FontAwesomeIcon icon={faChevronLeft} /> Prev
          </button>
          <span>Page {currentPage} of {totalPages}</span>
          <button onClick={nextPage} disabled={currentPage === totalPages}>
            Next <FontAwesomeIcon icon={faChevronRight} />
          </button>
        </div>
      )}
    </div>
  );
};

export default AllCoursesVideos;